import AnimatedCharacter from './components/AnimatedCharacter';
import FallbackCharacter from './components/FallbackCharacter';
import MotionTrails from './components/MotionTrails';
import PlayerCameraButtons from './components/PlayerCameraButtons';
import PlayerCameraControlsOverlay from './components/PlayerCameraControlsOverlay';
import PlayerCameraControls, {
  type PlayerCameraControlsProps,
} from './components/PlayerCameraControls';
import PlayerCanvas from './components/PlayerCanvas';
import PlayerControls from './components/PlayerControls';
import PlayerDefaultCamera from './components/PlayerDefaultCamera';
import PlayerEnvironment from './components/PlayerEnvironment';
import PlayerRoot from './components/PlayerRoot';

export {
  applyPlayerPerspectiveClippingForFraming,
  boundsForPlayerCharacter,
  fitBoundingSpherePerspectiveDistance,
  fitBoxPerspectiveDistance,
  fitPlayerCameraToCharacter,
  getFitPlayerCameraPoseForBox,
  getFitPlayerCameraPose,
} from './lib/fitPlayerCameraToCharacter';
export { centerPlayerCameraOnTarget } from './lib/centerPlayerCameraOnTarget';
export {
  isPlayerCameraUpdateBlocked,
  isPlayerCharacterFitBlocked,
} from './lib/isPlayerCameraUpdateBlocked';
export type {
  FitPlayerCameraPose,
  FitPlayerCameraToCharacterOptions,
} from './lib/fitPlayerCameraToCharacter';
export { defaultPlayerSettings } from './hooks/playerSettingsContext';
export { usePlayer } from './hooks/usePlayer';
export { usePlayerActions } from './hooks/usePlayerActions';
export { usePlayerActorAssetStatus } from './hooks/usePlayerActorAssetStatus';
export { usePlayerActorScene } from './hooks/usePlayerActorScene';
export { usePlayerAssetStatus } from './hooks/usePlayerAssetStatus';
export { usePlayerCameraControls } from './hooks/usePlayerCameraControls';
export { usePlayerFollowTarget } from './hooks/usePlayerFollowTarget';
export { usePlayerResolvedAnimation } from './hooks/usePlayerResolvedAnimation';
export { useResolvedPlayerAnimation } from './hooks/useResolvedPlayerAnimation';
export { usePlayerSettings } from './hooks/usePlayerSettings';
export { usePlayerTimeline } from './hooks/usePlayerTimeline';
export { usePlayerStore, usePlayerStoreApi } from './store/playerStore';
export type {
  DeepPartial,
  PlayerCameraControlsHandle,
  PlayerCameraInputMode,
  PlayerActorState,
  PlayerActorAssetStatus,
  PlayerAnimationSource,
  PlayerAssetLoadStatus,
  PlayerAssetStatuses,
  PlayerAssetStatusState,
  PlayerResolvedAnimation,
  PlayerResolvedAnimationKind,
  PlayerCenterOnTargetOptions,
  PlayerDuration,
  PlayerCameraState,
  PlayerFollowTarget,
  PlayerMixer,
  PlayerSettings,
  PlayerTransportState,
} from './types';

export type { CharacterMeshFormat } from './components/AnimatedCharacter';
export type { PlayerRootProps } from './components/PlayerRoot';
export type { PlayerCharacterMeshOverrides } from './hooks/playerCharacterMeshContext';
export {
  PlayerCharacterMeshProvider,
  usePlayerCharacterMeshOverrides,
} from './hooks/playerCharacterMeshContext';
export { ACTOR_ACCENT_BG_CLASSES } from './components/ReferenceNameTags';
export type { MotionTrailsProps } from './components/MotionTrails';
export type { PlayerCameraControlsProps };
export {
  AnimatedCharacter,
  FallbackCharacter,
  MotionTrails,
  PlayerCameraButtons,
  PlayerCameraControls,
  PlayerCameraControlsOverlay,
  PlayerCanvas,
  PlayerControls,
  PlayerDefaultCamera,
  PlayerEnvironment,
  PlayerRoot,
};

export const Player = {
  Root: PlayerRoot,
  CameraButtons: PlayerCameraButtons,
  CameraControlsOverlay: PlayerCameraControlsOverlay,
  DefaultCamera: PlayerDefaultCamera,
  CameraControls: PlayerCameraControls,
  Canvas: PlayerCanvas,
  Environment: PlayerEnvironment,
  Character: AnimatedCharacter,
  MotionTrails,
  FallbackCharacter,
  Controls: PlayerControls,
};
